import history from 'app/common/history';
import {
  routerMiddleware,
  connectRouter,
  RouterState,
} from 'connected-react-router';
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  ReducersMapObject,
  Store,
} from 'redux';
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga';

import { ridiReducer, RidiState } from 'app/common/ridi.store/ridi.reducer';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}

export interface RootState {
  ridi: RidiState;
  router: RouterState;
}

export class RidiCommonStore {
  private constructor() {}

  private static instance: RidiCommonStore;
  public static getInstance() {
    return RidiCommonStore.instance
      ? RidiCommonStore.instance
      : (RidiCommonStore.instance = new RidiCommonStore());
  }

  private store: Store<any>;
  private sagaMiddleware: SagaMiddleware<any>;
  private reducers: ReducersMapObject = {
    ridi: ridiReducer,
    router: connectRouter(history),
  };

  private initializeStore() {
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const combinedRouterMiddleware = routerMiddleware(history);
    this.store = createStore(
      combineReducers(this.reducers),
      composeEnhancers(
        applyMiddleware(this.sagaMiddleware, combinedRouterMiddleware),
      ),
    );
  }

  public getStore<T>() {
    if (!this.store) {
      this.sagaMiddleware = createSagaMiddleware();
      this.initializeStore();
    }
    return this.store as Store<T & RootState>;
  }

  public injectReducers(newReducers: ReducersMapObject) {
    this.reducers = {
      ...this.reducers,
      ...newReducers,
    };
    if (this.store) {
      this.store.replaceReducer(combineReducers(this.reducers));
    }
    return this;
  }

  public injectSaga(saga: any) {
    if (!!this.sagaMiddleware && saga) {
      this.sagaMiddleware.run(saga);
    }
    return this;
  }
}

export const commonStore = RidiCommonStore.getInstance();



// WEBPACK FOOTER //
// ./common/ridi.store/ridi.commonStore.ts